import { DatePicker } from '@/components/formFields/common';
import MedicareNumber from '@/components/formFields/MedicareNumber';
import {
  isBeforeToday, regex, required
} from '@/validators';

export * from '@/components/requestWizard/contactInfoFields';

const currentYear = (new Date()).getFullYear();

export const birthDate = {
  label: 'Date of Birth',
  componentType: DatePicker,
  class: 'col-md-6',
  yearRange: [currentYear - 100, currentYear - 20],
  rules: {
    required,
    isBeforeToday
  },
  description: 'Enter a date (M/D/YYYY) or choose from the calendar'
};

export const medicareNum = {
  label: 'Medicare Number',
  componentType: MedicareNumber,
  class: 'col-md-6',
  rules: {
    /**
     * This will validate an MBI without dashes.
     * Alphabetic values A-Z (minus S,L,O,I,B,Z):               (?![sloibz])[a-z]{1}
     * Alpha-numeric values 0-9 and A-Z (minus S,L,O,I,B,Z):    (?![sloibz])[0-9a-z]{1}
     * Numeric values 1-9:                                      [1-9]{1}
     * Numeric values 0-9:                                      \d{1}
     * See https://www.cms.gov/medicare/new-medicare-card/understanding-the-mbi-with-format.pdf.
     */
    regex: regex(/^[1-9]{1}(?![sloibz])[a-z]{1}(?![sloibz])[0-9a-z]{1}\d{1}-{1}(?![sloibz])[a-z]{1}(?![sloibz])[0-9a-z]{1}\d{1}-{1}(?![sloibz])[a-z]{1}(?![sloibz])[a-z]{1}\d{1}\d{1}$/i)
  },
  mask: {
    mask: 'CA*N-A*N-AANN',
    autoUnmask: false,
    definitions: {
      C: { validator: '[1-9]', casing: 'upper' },
      N: { validator: '[0-9]', casing: 'upper' },
      A: { validator: '(?![SLOIBZsloibz])[A-Za-z]', casing: 'upper' },
      '*': { validator: '(?![SLOIBZsloibz])[0-9A-Za-z]', casing: 'upper' }
    }
  }
};
